export const loginreq="loginreq"
export const loginsucc="loginsucc"
export const loginfail="loginfail"